module.exports = "<md-toolbar ng-class=\"isCardLayout ? 'md-tall-on-md md-whiteframe-z1' : ''\">\n  <div class=\"md-toolbar-tools {{ isCardLayout ? 'md-toolbar-tools-bottom' : '' }}\" layout=\"row\">\n    <md-button class=\"hamburger md-icon-button\" ng-click=\"toggleLeftNav()\">\n      <i class=\"fa fa-bars\"></i>\n    </md-button>\n\n    <div ncy-breadcrumb class=\"f-breadcrumbs-toolbar\"></div>\n\n    <span flex></span>\n\n    <md-button ui-sref=\"login\" ng-hide=\"fSession.isLoggedIn()\">Login</md-button>\n  </div>\n</md-toolbar>\n"


//////////////////
// WEBPACK FOOTER
// ./toolbar/tpl.html
// module id = 1240
// module chunks = 0